import { AdminNotificationList } from "@/components/admin/notifications/AdminNotificationList";
import { AdminSidebar } from "@/components/AdminSidebar";
import { DashboardHeader } from "@/components/DashboardHeader";
import { DashboardFooter } from "@/components/DashboardFooter";
import { SidebarProvider } from "@/components/ui/sidebar";

const AdminNotifications = () => {
  return (
    <div className="min-h-screen bg-[#1A1F2C]">
      <SidebarProvider>
        <div className="flex min-h-screen w-full">
          <AdminSidebar />
          <div className="flex-1 flex flex-col min-h-screen bg-[#1A1F2C]">
            <DashboardHeader />
            <main className="flex-1 px-6 py-8 mt-16">
              <div className="max-w-4xl">
                <h1 className="text-3xl font-bold text-white mb-8">Notifications Management</h1>
                <AdminNotificationList />
              </div>
            </main>
            <DashboardFooter />
          </div>
        </div>
      </SidebarProvider>
    </div>
  );
};

export default AdminNotifications;